import { render, staticRenderFns } from "./afterSaleStep.vue?vue&type=template&id=a80c47ae&scoped=true"
import script from "./afterSaleStep.vue?vue&type=script&lang=js"
export * from "./afterSaleStep.vue?vue&type=script&lang=js"
import style0 from "./afterSaleStep.vue?vue&type=style&index=0&id=a80c47ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c47ae",
  null
  
)

export default component.exports